<div class="row_main">

    <div class="row">

        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top animate__animated animate__fadeIn">
            <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">

                <!-- MIS DATOS -->
                <mat-tab label="Mis datos">
                    <div class="row animate__animated animate__fadeIn">
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" >
                            <mat-card class="mtb">
                                <mat-card-content>
                                    <h1 class="titulo-simpli">mis datos de acceso</h1>
                                    <small class="subtitulo-simpli">Actualiza tu información de usuario</small>

                                    <form [formGroup]="formGroup" style="margin-top: 20px;">

                                        <mat-form-field class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                            <mat-label>Nombre</mat-label>
                                            <input matInput formControlName="first_name" required />
                                            <mat-hint>Indique su nombre</mat-hint>
                                            <mat-error *ngIf="formGroup.controls['first_name'].hasError('required')">
                                                El nombre es <strong>requerido</strong>
                                            </mat-error>
                                        </mat-form-field>

                                        <mat-form-field class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                            <mat-label>Apellido</mat-label>
                                            <input matInput formControlName="last_name" required />
                                            <mat-hint>Indique su apellido</mat-hint>
                                            <mat-error *ngIf="formGroup.controls['last_name'].hasError('required')">
                                                El apellido es <strong>requerido</strong>
                                            </mat-error>
                                        </mat-form-field>

                                        <mat-form-field class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                            <mat-label>Correo electrónico</mat-label>
                                            <input matInput formControlName="email" type="email" />
                                            <mat-hint>El correo no se puede modificar</mat-hint>
                                        </mat-form-field>

                                    </form>

                                    <button mat-raised-button color="primary" class="primary-button"
                                        (click)="submitProfile()" [disabled]="formGroup.invalid || showSpinner"
                                        style="margin-top:20px">
                                        <span *ngIf="!showSpinner">Guardar</span>
                                        <span *ngIf="showSpinner"><i class="fa-solid fa-spinner fa-spin-pulse"></i></span>
                                    </button>

                                </mat-card-content>
                            </mat-card>
                        </div>
                    </div>
                </mat-tab>

                <!-- CAMBIAR CONTRASEÑA -->
                <mat-tab label="Cambiar contraseña">
                    <div class="row" style="margin-bottom: 20px;">
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <app-password />
                        </div>
                    </div>
                </mat-tab>

            </mat-tab-group>
        </div>

    </div>
</div>
